const req = require.context('../assets/icons/svgs', false, /\.svg$/);
const requireAll = requireContext => {
  requireContext.keys().map(requireContext);
};
requireAll(req);
